import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
var __jsx = React.createElement;
import * as React from 'react';
import * as filter from '../Filters';
export function Filters(_ref) {
  var engine = _ref.engine;
  var filters = getAllFilters(engine.result, engine.query);
  return __jsx(filter.Filters, {
    engine: engine,
    filters: filters
  });
}

function getAllFilters(result, query) {
  var filters = Object.entries(result.facets).reduce(function (filtersAccumulator, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        indexHash = _ref3[0],
        index = _ref3[1];

    var facet = result.facets[indexHash];
    var indexQuery = query.value.filters[indexHash] || [];
    var formattedFilters = formatFilters(index.buckets, indexQuery, facet);
    if (formattedFilters && formattedFilters.length > 1) filtersAccumulator.push({
      filterSlug: indexHash,
      filterTitle: facet.title,
      filterValues: formattedFilters
    });
    return filtersAccumulator;
  }, []);
  return filters;
}

function formatFilters(buckets, selected, facet) {
  return Object.entries(buckets).filter(function (_ref4) {
    var _facet$buckets$bucket;

    var _ref5 = _slicedToArray(_ref4, 1),
        buckets = _ref5[0];

    if (selected.some(function (selection) {
      return selection === buckets;
    })) return true;
    return ((_facet$buckets$bucket = facet.buckets[buckets]) === null || _facet$buckets$bucket === void 0 ? void 0 : _facet$buckets$bucket.count) > 1;
  }).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        bucket = _ref7[0],
        bucketIndex = _ref7[1];

    return {
      name: bucketIndex.title,
      id: bucket,
      isSelected: selected.some(function (selection) {
        return selection === bucket;
      })
    };
  });
}